import PageHero from "../components/PageHero";
import FinalCTA from "../components/sections/FinalCTA";

const CONTENT = [
  ["Acceptance of Terms", "By using this website, you agree to the following terms of use. If you do not agree, please do not use this website."],
  ["Services", "Emilio's Solutions provides professional residential and commercial cleaning services in Singapore. All quotations are subject to onsite confirmation."],
  ["Intellectual Property", "All content on this website, including text and images, is the property of Emilio's Solutions unless credited otherwise."],
  ["Limitation of Liability", "We aim to deliver a professional standard on every job. Some outcomes — such as complete stain removal or defect detection — cannot be guaranteed."],
  ["Third-Party Links", "This website may link to third-party services (e.g. WhatsApp). We are not responsible for the content or availability of those services."],
  ["Governing Law", "These terms are governed by the laws of Singapore."],
  ["Contact", "For any questions regarding these terms, email emiliosolutions@gmail.com."],
];

export default function Terms() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        headline={"Terms of Use."}
        image="/generated/hero_whyus.png"
        imageAlt=""
        compact
        showQuoteForm={false}
      />
      <section className="bg-ink py-20 md:py-28">
        <div className="container-emilio max-w-3xl">
          <div className="space-y-10">
            {CONTENT.map(([title, body], i) => (
              <div key={i}>
                <div className="text-emerald font-mono text-xs mb-2">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h2 className="font-display font-bold text-white text-2xl md:text-3xl">
                  {title}
                </h2>
                <p className="mt-3 text-mutedtext leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
